import { render, staticRenderFns } from "./SearchTabsTheme0.vue?vue&type=template&id=4dd05c7e&scoped=true"
import script from "./SearchTabsTheme0.vue?vue&type=script&lang=js"
export * from "./SearchTabsTheme0.vue?vue&type=script&lang=js"
import style0 from "./SearchTabsTheme0.vue?vue&type=style&index=0&id=4dd05c7e&prod&lang=less&scoped=true"
import style1 from "./SearchTabsTheme0.vue?vue&type=style&index=1&id=4dd05c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd05c7e",
  null
  
)

export default component.exports